import React, {useEffect, useMemo, useRef, useState} from 'react';
import UtcToLocal from "../../components/UtcToLocal";
import {capitalizeFirstLetters, formatAccount} from "../../features/ValueFormater";
import TransferListSkeleton from "../../components/skeletons/TransferListSkeleton";
import {usePagination, useTable} from "react-table";
import RecordsMessage from "../../components/RecordsMessage";
import Table from "../../components/Table";
import Pagination from "../../components/Pagination";
import PaymentRequestAPI from "../../api/PaymentRequestAPI";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown} from "@fortawesome/free-solid-svg-icons";
import useCardsAPI from "../../api/CardsAPI";
import "./../../utils/Style/pages/CardTransactions.scss";
import HeaderComponent from "../../components/HeaderComponent";
import {useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {setFlag} from "../../features/responseSlice";
import DatePicker from "../../components/DatePicker";

function CardTransactions() {
    const [totalNbPage, SetTotalNbPage] = useState(1);
    const [selectedPage, setSelectedPage] = useState(1);
    const [activeRowIndex, setActiveRowIndex] = useState(-1);
    const [holder, setHolder] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [transactionId, setTransactionId] = useState(null);
    const [error, setError] = useState("");

    const [dateRange, setDateRange] = useState([
        new Date(new Date().setMonth(new Date().getMonth() - 1)),
        new Date(),
    ]);

    const dispatch = useDispatch();
    const {flag} = useSelector((state) => state.transferResponse);

    const {
        GetCardTransactions,
        cardTransactions,
        cardTransactionsLoading,
        totalNbOfPage,
        totalCount,
        UploadCardTransactionInvoice,
        GetCardHolderData,
        cardHolderData
    } = useCardsAPI();

    const {cardId} = useParams();


    useEffect(() => {
        if (dateRange) {
            const startDate = new Date(Date.UTC(dateRange[0].getUTCFullYear(), dateRange[0].getUTCMonth(), dateRange[0].getUTCDate()));
            const endDate = new Date(Date.UTC(dateRange[1].getUTCFullYear(), dateRange[1].getUTCMonth(), dateRange[1].getUTCDate()));
            const startDateString = startDate.toISOString().substring(0, 10);
            const endDateString = endDate.toISOString().substring(0, 10);

            GetCardTransactions(cardId || 0, holder, selectedPage, startDateString, endDateString);
            GetCardHolderData();
        }
        if (flag === 0) {
            dispatch(setFlag(null));
        }
    }, [selectedPage, holder, flag]);

    useEffect(() => {
        if (cardTransactions?.length > 0)
            SetTotalNbPage(totalNbOfPage);
    }, [cardTransactions]);


    useEffect(() => {
        if (selectedFile && sessionStorage.getItem("EntityRole") !== "VIEWER") {
            const fileSizeLimit = 2 * 1024 * 1024; // 2 MB
            if (selectedFile.size > fileSizeLimit) {
                setError("File should not be larger than 2MB.");
            } else {
                setError("");

                const reader = new FileReader();
                reader.readAsDataURL(selectedFile);
                reader.onloadend = () => {
                    const base64String = reader.result;
                    const payload = {
                        ReasonFileName: selectedFile.name,
                        ReasonFile: base64String,
                        TransactionID: transactionId,
                    };
                    UploadCardTransactionInvoice(payload).finally(() => {
                        setSelectedFile(null);
                    })
                };
            }
        }
    }, [selectedFile]);

    const options = {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    };

    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
        }
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };


    const columns = useMemo(() => [
        {
            Header: "Transaction",
            accessor: "Transaction",
        },
        {
            Header: "Date",
            accessor: "Date",
            Cell: ({value}) => {
                return <UtcToLocal utcTimestamp={value} options={options}/>;
            }
        },
        {
            Header: "",
            accessor: "details",
            Cell: ({row}) => {
                return <button className="showmore" onClick={() => {
                    setActiveRowIndex(row.index)
                }}><FontAwesomeIcon icon={faArrowDown}/></button>
            },
        },
        {
            Header: "Card Holder",
            accessor: "CardHolder",
            Cell: ({value}) => {
                return capitalizeFirstLetters(value);
            }
        },
        {
            Header: "Amount",
            accessor: "Amount",
            Cell: ({value, row}) => {
                const currencyId = row.original?.Currency === "USD" ? 1 : 2;
                return <span>{formatAccount(value, currencyId)}</span>
            }
        },
        {
            Header: "Merchant",
            accessor: "Merchant",
        },
        {
            Header: "Reason",
            accessor: "Reason",
        },
        {
            Header: "Invoice",
            accessor: "Invoice",
            Cell: ({row, value}) => {
                if (value)
                    return (<a
                        className="remind-btn"
                        href={row.original.DocumentUrl}
                    >{value}</a>);
                else
                    return (
                        <div className="file-input-button">
                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{display: 'none'}}
                                onChange={handleFileChange}
                            />
                            <button id="repeat-btn" onClick={() => {
                                setTransactionId(row.original.Transaction)
                                handleButtonClick()
                            }

                            }>Upload Invoice
                            </button>
                        </div>
                    )
            }
        }
    ], [cardTransactions]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow
    } = useTable({columns, data: cardTransactions || []}, usePagination);




    return (
        <div className="CardsSettingsPage">
            <HeaderComponent title="Cards Settings"/>
            <div className="CardsSettingsPagecontainer card-transactions">
                <div className="table-cont">
                    <div className="Filtering">
                        <RecordsMessage totalCount={totalCount} selectedPage={selectedPage}
                                        records="Card Transactions"/>
                        <div className="Filter">
                            <DatePicker
                                value={dateRange}
                                onChange={setDateRange}
                            />
                            <select className="search" placeholder="Search" onChange={(e)=>{
                                setHolder(e.target.value);
                            }}>
                                <option value="">All Cards</option>
                                {cardHolderData?.map(({UserAccountID, Name}) => (
                                    <option key={UserAccountID} value={UserAccountID}>{Name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    {
                        cardTransactionsLoading ?
                            <TransferListSkeleton/>
                            :

                            <div>
                                <Table
                                    headerGroups={headerGroups}
                                    page={page}
                                    prepareRow={prepareRow}
                                    getTableProps={getTableProps}
                                    getTableBodyProps={getTableBodyProps}
                                    totalNbPage={totalNbPage}
                                    activeRowIndex={activeRowIndex}
                                />
                                <Pagination
                                    getData={GetCardTransactions}
                                    totalNbPage={totalNbPage}
                                    method="cardTransactions"
                                    selectedPage={selectedPage}
                                    setSelectedPage={setSelectedPage}
                                    cardId={cardId}
                                    holder={holder}
                                />
                            </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default CardTransactions;
